import { render, staticRenderFns } from "./HumidityStatistics.vue?vue&type=template&id=044a894e&scoped=true&"
import script from "./HumidityStatistics.vue?vue&type=script&lang=js&"
export * from "./HumidityStatistics.vue?vue&type=script&lang=js&"
import style0 from "./HumidityStatistics.vue?vue&type=style&index=0&id=044a894e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a894e",
  null
  
)

export default component.exports